import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useRef, useState } from 'react'
import { useForm, useFieldArray } from 'react-hook-form'
import ComboBox from '../../../../Components/ComboBox'
import CustomButton from '../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../utils/api'
import AddCircleIcon from '@mui/icons-material/AddCircle'

import urls from '../../../../utils/urls'
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { Delete as DeleteIcon } from '@mui/icons-material'
import { width } from '@fortawesome/free-solid-svg-icons/faInfo'
import CircularProgress from '@mui/material/CircularProgress'
export default function CreateOperationForm({ setOperations }) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [title, setTitle] = useState('Ajouter recette')
  const [image, setImage] = useState(null)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const [categorie, setCategorie] = useState([])
  const [plat, setPlat] = useState([])
  const [cuisine, setCuisine] = useState([])
  const [repas, setRepas] = useState([])
  const [unit, setUnits] = useState([])
  const [unitValues, setUnitValues] = useState({})
  const inputNom = useRef()

  const inputNoPerson = useRef()
  const inputTypeDeRepas = useRef()

  const { handleSubmit, control, setValue, reset, getValues } = useForm({
    defaultValues: {
      Nom: '',
      Servir: '',
      TypeDeRepas: '',
      Description: '',
      TempsDePreparationH: '',
      TempsDePreparationMin: '',
      TempsDeCuissonH: '',
      TempsDeCuissonMin: '',
      ingredientsdata: [{ Nom: '', Quantite: '', UM: '', Index: 0 }],
      instructiondata: [{ Numero: '', Index: 0 }],
    },
  })
  const {
    fields: ingredientsfields,
    insert: ingredientsinsert,
    remove: removeIngredients,
  } = useFieldArray({
    control,
    name: 'ingredientsdata',
  })
  const {
    fields: instructionfields,
    insert: instructioninsert,
    remove: removeInstruction,
  } = useFieldArray({
    control,
    name: 'instructiondata',
  })

  useEffect(() => {
    fetchFilters()
  }, [])

  const handleClickOpen = () => {
    setOpen(true)
  }
  const seasons = [
    { id: 1, label: 'Hiver' },
    { id: 2, label: 'Printemps' },
    { id: 3, label: 'Été' },
    { id: 4, label: 'Automne' },
    { id: 5, label: 'Toutes' },
  ]
  const fetchFilters = async () => {
    const url = urls.getFilters + '?all=true'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      setCategorie(data.category)
      setPlat(data.plat)
      setCuisine(data.cuisine)
      setRepas(data.repas)
      setUnits(data.unit)
    }
  }
  const handleClose = () => {
    setOpen(false)
    reset()
    setUnitValues({})
    setLoading(false)
  }

  const onSubmit = async (data) => {
    const iidata = []
    data.ingredientsdata.forEach((v) => {
      iidata.push({ ...v, UM: v.UM?.id })
    })

    const payload = {
      ...data,
      TypeDeRepas: data.TypeDeRepas.label,
      Season: data.Season.label,
      TempsDePreparationH: data.TempsDePreparationH || 0,
      TempsDeCuissonH: data.TempsDeCuissonH || 0,
      TempsDePreparationMin: data.TempsDePreparationMin || 10,
      TempsDeCuissonMin: data.TempsDeCuissonMin || 10,
      // TypeDePlat: data.TypeDePlat.id,
      // TypeDeCuisine: data.TypeDeCuisine.id,
      // ingredientsdata: iidata,
    }
    if (data.Categorie) {
      payload['Categorie'] = data.Categorie.id
    }
    if (data.TypeDePlat) {
      payload['TypeDePlat'] = data.TypeDePlat.id
    }
    if (data.TypeDeCuisine) {
      payload['TypeDeCuisine'] = data.TypeDeCuisine.id
    }
    delete payload['ingredientsdata']
    delete payload['instructiondata']

    const formData = new FormData()
    if (image != null) formData.append('Image', image)
    for (const key in payload) {
      formData.append(`${key}`, `${payload[key]}`)
    }
    const response = await makePostRequest(
      urls.crudRecettesOperations,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      true,
    )
    if (response.status === 201) {
      let res_data = response.data
      setOperations((operations) => ({
        ...operations,
        results: [...operations?.results, res_data],
        count: operations.count + 1,
      }))

      data.ingredientsdata.forEach(async (v) => {
        const payload = {
          RecipeId: res_data.id,
          Nom: v.Nom,
          RecipeName: res_data.Nom,
          Quantite: v.Quantite,
          Numero: v.Index,
          UM: v.UM?.id,
        }
        const res = await makePostRequest(urls.crudIngredientsOperations, payload, {}, true)
        if (res.status === 201) {
          const newPayload = {
            ...payload,
            IngredientId: res.data.id,
            NomIngredient: res.data.Nom,
          }
          makePostRequest(urls.crudBillofingredientsOperations, newPayload, {}, true)
        }
      })
      data.instructiondata.forEach((v, index) => {
        const payload = {
          Recette: res_data.id,
          Numero: index + 1,
          Description: v.Numero,
        }
        makePostRequest(urls.crudInstructionOperations, payload, {}, true)
      })
      handleClose()
    }
  }
  const handleOpenAi = async () => {
    const inputValue = getValues('Nom')

    if (!inputValue || !inputValue.trim()) {
      inputNom.current.focus()
      return
    }
    const TypeDeRepas = getValues('TypeDeRepas')

    if (!TypeDeRepas) {
      inputTypeDeRepas.current.focus()
      return
    }
    const inputNo = getValues('Servir')

    if (!inputNo || !inputNo.trim()) {
      inputNoPerson.current.focus()
      return
    }
    // reset({
    //   ingredientsdata: [{ Nom: '', Quantite: '', UM: '', Index: 0 }],
    //   instructiondata: [{ Numero: '', Index: 0 }],
    // })
    ingredientsfields.forEach((el, index) => {
      removeIngredients(0)
    })
    instructionfields.forEach((el, index) => {
      removeInstruction(0)
    })
    ingredientsfields.forEach((el, index) => {
      removeIngredients(0)
    })
    instructionfields.forEach((el, index) => {
      removeInstruction(0)
    })
    setValue('Description', '')
    setValue('TempsDePreparationH', '')
    setValue('TempsDePreparationMin', '')
    setValue('TempsDeCuissonH', '')
    setValue('TempsDeCuissonMin', '')
    // return
    setLoading(true)
    const payload = { name: inputValue, noofpeople: inputNo }
    const response = await makePostRequest(
      '/api/Personnal/genrate-openai-detail/',
      payload,
      {},
      true,
    )
    if (response.status === 200) {
      setLoading(false)
      let res_ingredients = response.data.ingredients
      let res_instructions = response.data.instructions
      const [cook_hours, cook_minutes] = response.data.cook_time.split(':')
      const [prep_hours, prep_minutes] = response.data.prep_time.split(':')
      setValue('Description', response.data.description)
      setValue('TempsDePreparationH', prep_hours)
      setValue('TempsDePreparationMin', prep_minutes)
      setValue('TempsDeCuissonH', cook_hours)
      setValue('TempsDeCuissonMin', cook_minutes)
      // L'Autocomplete Unité est piloté par `unitValues` (state) : un simple
      // setValue() ne suffit pas à l'afficher, le champ restait vide.
      // Les lignes sont aussi insérées dans l'ordre (insert(index)) sinon la
      // ligne remplie et l'unité posée sur `ingredientsdata.${index}` divergent.
      const filledUnits = {}
      res_ingredients.forEach((el, index) => {
        const matchedUnit = unit.find((uel) => uel.id === parseInt(el.unit, 10))
        ingredientsinsert(index, {
          Nom: el.name,
          Quantite: el.quantity,
          UM: matchedUnit || '',
          Index: index,
        })
        setValue(`ingredientsdata.${index}.UM`, matchedUnit || '')
        if (matchedUnit) {
          filledUnits[index] = matchedUnit
        }
      })
      setUnitValues(filledUnits)
      res_instructions.forEach((el, index) => {
        instructioninsert(index, {
          Numero: el.description,
          Index: index,
        })
      })
    } else {
      setLoading(false)
      // 402 = crédits insuffisants : l'intercepteur axios affiche déjà la
      // modale dédiée, inutile de doubler avec une alerte générique.
      if (response?.status === 402) {
        return
      }
      alert(
        response?.data?.detail ||
          'Le détail de la recette n’a pas pu être généré, réessayez ultérieurement',
      )
    }
  }
  return (
    <>
      {isMobile ? (
        <AddCircleIcon onClick={handleClickOpen} />
      ) : (
        <CustomButton onClick={handleClickOpen}>Ajouter</CustomButton>
      )}
      <Dialog fullWidth maxWidth="sm" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{title}</DialogTitle>

        <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
          <DialogContent>
            <Input
              inputRef={inputNom}
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Nom"
              label="Nom de la recette"
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Categorie', j)
              }}
              label="Catégorie"
              data={categorie}
              name="Categorie"
              // required={true}
            />
            <ComboBox
              inputRef={inputTypeDeRepas}
              handleAutoComplete={(e, j) => {
                setValue('TypeDeRepas', j)
              }}
              label="Type de repas"
              data={repas}
              name="TypeDeRepas"
              required={true}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('TypeDePlat', j)
              }}
              label="Type de plat"
              data={plat}
              name="TypeDePlat"
              // required={true}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Season', j)
              }}
              label="Saison"
              data={seasons}
              name="Season"
              required={true}
            />
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('TypeDeCuisine', j)
              }}
              label="Type de cuisine"
              data={cuisine}
              name="TypeDeCuisine"
              // required={true}
            />

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                fontWeight: 700,
                whiteSpace: 'nowrap',
              }}
            >
              Temps de préparation
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  // required: true,
                  size: 'small',
                }}
                // rules={{ required: true }}
                name="TempsDePreparationH"
                label="H"
              />
              H
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  // required: true,
                  size: 'small',
                }}
                // rules={{ required: true }}
                name="TempsDePreparationMin"
                label="min"
              />
              min
            </Box>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',

                fontWeight: 700,
                whiteSpace: 'nowrap',
              }}
            >
              Temps de cuisson
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  // required: true,
                  size: 'small',
                }}
                // rules={{ required: true }}
                name="TempsDeCuissonH"
                label="H"
              />
              H
              <Input
                control={control}
                inputProps={{
                  variant: 'outlined',
                  type: 'number',
                  // required: true,
                  size: 'small',
                }}
                // defaultValues={getValues('TempsDeCuissonMin')}
                // slotProps={{ inputLabel: { shrink: true } }}
                // rules={{ required: true }}
                name="TempsDeCuissonMin"
                label="min"
              />
              min
            </Box>
            <Input
              inputRef={inputNoPerson}
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="Servir"
              label="Nombre de personne"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                // required: true,
                size: 'small',
              }}
              rows={4}
              multiline
              // rules={{ required: true }}
              name="Description"
              label="Description recette"
            />

            <Box
              display={'flex'}
              sx={{ width: 'fit-content', ':hover': { cursor: 'pointer' } }}
              onClick={() =>
                ingredientsinsert(100, {
                  Nom: '',
                  Quantite: '',
                  UM: '',
                  Index: ingredientsfields.length + 1,
                })
              }
            >
              <Box component={'span'} fontSize={24} fontWeight={600}>
                Ingredients
              </Box>{' '}
              <AddIcon sx={{ color: '#1976d2', marginLeft: '5px', fontSize: '40px' }} />
            </Box>
            {ingredientsfields.map((item, index) => {
              return (
                <Box
                  key={item.id}
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box sx={{ width: '100%' }}>
                    <Input
                      control={control}
                      inputProps={{
                        variant: 'outlined',
                        type: 'text',
                        required: true,
                        size: 'small',
                      }}
                      rules={{ required: true }}
                      name={`ingredientsdata.${index}.Nom`}
                      label="Ingrédients"
                    />
                  </Box>
                  <Box>
                    <Input
                      control={control}
                      inputProps={{
                        variant: 'outlined',
                        type: 'number',
                        required: true,
                        size: 'small',
                      }}
                      rules={{ required: true }}
                      name={`ingredientsdata.${index}.Quantite`}
                      label="Quantité"
                    />
                  </Box>
                  <Box sx={{ '.MuiAutocomplete-root': { minWidth: '125px' } }}>
                    <ComboBox
                      sx={{ marginTop: '-10px' }}
                      handleAutoComplete={(e, j) => {
                        setUnitValues((prev) => ({
                          ...prev,
                          [index]: j,
                        }))
                        setValue(`ingredientsdata.${index}.UM`, j)
                      }}
                      label="Unité"
                      data={unit}
                      name={`ingredientsdata.${index}.UM`}
                      selectedValue={unitValues[index] || getValues(`ingredientsdata.${index}.UM`)}
                      required={true}
                    />
                  </Box>
                  <IconButton color="error" onClick={() => removeIngredients(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )
            })}
            <Box
              display={'flex'}
              sx={{ width: 'fit-content', ':hover': { cursor: 'pointer' } }}
              onClick={() =>
                instructioninsert(100, {
                  Numero: '',
                  Index: ingredientsfields.length + 1,
                })
              }
            >
              <Box component={'span'} fontSize={24} fontWeight={600}>
                Instructions
              </Box>
              <AddIcon sx={{ color: '#1976d2', marginLeft: '5px', fontSize: '40px' }} />
            </Box>
            {instructionfields.map((item, index) => {
              return (
                <Box display={'flex'} key={index}>
                  <Input
                    classAttr="instrut_input"
                    key={item.id}
                    control={control}
                    inputProps={{
                      variant: 'outlined',
                      type: 'text',
                      required: true,
                      size: 'small',
                    }}
                    rules={{ required: true }}
                    name={`instructiondata.${index}.Numero`}
                    label="Instructions"
                  />
                  <IconButton color="error" onClick={() => removeInstruction(index)}>
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )
            })}

            {/* <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="LienVideo"
              label="Lien vidéo"
            /> */}
            <Box component={'h6'} mt={3}>
              Upload Image
            </Box>
            <Button
              variant="contained"
              component="label"
              sx={{
                width: '100%',
                color: 'black',
                background: 'none',
                '&:hover': {
                  backgroundColor: '#aeaeae',
                },
                '& input': { width: '100%' },
              }}
            >
              <input
                name="Image"
                type="file"
                filename={image}
                // required={true}
                accept=".png, .jpg, .jpeg"
                onChange={(e) => setImage(e.target.files[0])}
              />
            </Button>
          </DialogContent>
          <DialogActions>
            <Box mr={'auto'} ml={3} sx={{ cursor: 'pointer' }}>
              <Button
                title="Génerer ingrédients et instructions via Life Agent" /* LAP-733 (GE022) */
                onClick={handleOpenAi}
                loading={loading}
                disabled={loading}
                loadingPosition="start"
              >
                {loading ? (
                  <CircularProgress />
                ) : (
                  <img src="/openai-svg.svg" style={{ height: 30 }} alt="oai" />
                )}
              </Button>
            </Box>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
